import React from 'react';

function Sidebar({ currentPage, setCurrentPage }) {
  return (
    <div className="sidebar">
      <div className="logo">
        <span className="logo-text">tyne</span>
        <span className="badge">EARLY</span>
      </div>

      <button className="model-selector">
        <svg viewBox="0 0 24 24" fill="currentColor">
          <circle cx="12" cy="12" r="10" fill="#4285f4"/>
        </svg>
        <span>Mini</span>
        <svg viewBox="0 0 24 24" fill="currentColor" style={{marginLeft: 'auto'}}>
          <path d="M7 10l5 5 5-5z"/>
        </svg>
      </button>

      <div className="nav-section">
        <button
          className={`nav-item ${currentPage === 'home' ? 'active' : ''}`}
          onClick={() => setCurrentPage('home')}
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
            <polyline points="9 22 9 12 15 12 15 22"/>
          </svg>
          Home
        </button>

        <button
          className={`nav-item ${currentPage === 'explore' ? 'active' : ''}`}
          onClick={() => setCurrentPage('explore')}
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="11" cy="11" r="8"/>
            <path d="m21 21-4.35-4.35"/>
          </svg>
          Explore
        </button>

        <button
          className={`nav-item ${currentPage === 'bookmarks' ? 'active' : ''}`}
          onClick={() => setCurrentPage('bookmarks')}
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/>
          </svg>
          Bookmarks
        </button>

        <button
          className={`nav-item ${currentPage === 'notifications' ? 'active' : ''}`}
          onClick={() => setCurrentPage('notifications')}
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/>
            <path d="M13.73 21a2 2 0 0 1-3.46 0"/>
          </svg>
          Notifications
        </button>

        <div className="divider"></div>

        <button
          className={`nav-item apps ${currentPage === 'apps' ? 'active' : ''}`}
          onClick={() => setCurrentPage('apps')}
        >
          <svg viewBox="0 0 24 24" fill="currentColor">
            <rect x="3" y="3" width="7" height="7" rx="1"/>
            <rect x="14" y="3" width="7" height="7" rx="1"/>
            <rect x="14" y="14" width="7" height="7" rx="1"/>
            <rect x="3" y="14" width="7" height="7" rx="1"/>
          </svg>
          Apps
        </button>

        <button
          className={`nav-item chats ${currentPage === 'chats' ? 'active' : ''}`}
          onClick={() => setCurrentPage('chats')}
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
          </svg>
          Chats
        </button>

        <button
          className={`nav-item browse ${currentPage === 'browse' ? 'active' : ''}`}
          onClick={() => setCurrentPage('browse')}
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10"/>
            <path d="M2 12h20"/>
            <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
          </svg>
          Browse
        </button>

        <button
          className={`nav-item images ${currentPage === 'images' ? 'active' : ''}`}
          onClick={() => setCurrentPage('images')}
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
            <circle cx="8.5" cy="8.5" r="1.5"/>
            <polyline points="21 15 16 10 5 21"/>
          </svg>
          Images
        </button>

        <button
          className={`nav-item documents ${currentPage === 'documents' ? 'active' : ''}`}
          onClick={() => setCurrentPage('documents')}
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
            <polyline points="14 2 14 8 20 8"/>
            <line x1="16" y1="13" x2="8" y2="13"/>
            <line x1="16" y1="17" x2="8" y2="17"/>
            <polyline points="10 9 9 9 8 9"/>
          </svg>
          Documents
        </button>

        <div style={{flex: 1}}></div>

        <button className="nav-item">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="3"/>
            <path d="M12 1v6m0 6v6M4.22 4.22l4.24 4.24m5.08 5.08l4.24 4.24M1 12h6m6 0h6M4.22 19.78l4.24-4.24m5.08-5.08l4.24-4.24"/>
          </svg>
          Settings
        </button>
      </div>
    </div>
  );
}

export default Sidebar;
